import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../client';
import { useTenant } from '../../hooks/useTenant';
import type { EventsParams } from '../types';
import { requireTenant } from './queryGuards';

export function useEvents(params: Omit<EventsParams, 'tenant_id'>) {
  const { tenantId } = useTenant();

  return useQuery({
    queryKey: ['events', tenantId, params],
    queryFn: () => {
      const requiredTenantId = requireTenant(tenantId);
      return apiClient.getEvents({ tenant_id: requiredTenantId, ...params });
    },
    enabled: !!tenantId && !!params.table,
  });
}
